import I18n from "i18n-js";
import React from "react";
import DataTable from "../DataTable/DataTable";
import ModalButtons from "../ModalButtons/ModalButtons";

export default class InsertUploads extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      images_selected: [],
    }
    this.onCheckBoxChange = this.onCheckBoxChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('add'),
        html_attributes: this.state.images_selected.length ? null : ['disabled=true'],
        button_classes: ['primary'],
        onClick: this.onSubmit,
      }
    ]
  
    return (
      <div className="RoomTypeBuilder">
        <div className="panel panel-form" style={{padding: 20}}>
          {this.props.filtered_images ? this.renderTableInformationMessage() : null}
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <DataTable
            endpoint={this.props.datatable_endpoint}
            no_data_text={I18n.t('none')}
            onCheckBoxChange={this.onCheckBoxChange}
            currency_unit={I18n.t('number.currency.format.unit')}
            delimiter={I18n.t('number.currency.format.delimiter')}
            separator={I18n.t('number.currency.format.separator')}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            origin={this.props.origin} />
        </div>
      </div>
    );
  };

  renderTableInformationMessage = () => {
    return(
      <div className="alert-warning room-type-images-warning-text">
        {this.props.origin == 'Messages' ? I18n.t('images_available_for_message_text') : I18n.t('images_available_for_room_types_text')}
      </div>
    );
  };

  onSubmit(e){
    e.preventDefault();
    e.stopPropagation();

    var uploads = [];
    $('.checked').each(function() {
      if (this.getAttribute('upload_file_name')) {
        var obj = {}

        obj.id = this.getAttribute('id')
        obj.original_url = this.getAttribute('original_url')
        obj.thumb_medium_url = this.getAttribute('src')
        obj.upload_file_name = this.getAttribute('upload_file_name')
        obj.upload_content_type = this.getAttribute('upload_content_type')
      }
      
      if (obj) {
        uploads.push(obj)
      }
    });

    if (typeof parent.window.insertUploads === 'function') {
      parent.window.insertUploads(uploads);
      parent.window.hide_modal()
    }
  }

  onCheckBoxChange(checkBoxes) {
    this.setState({images_selected: checkBoxes})
  }
}
